import httpService from "./httpService";
import utils from "./utils";

export default {
  get() {
    return httpService.get("user", null);
  },

  update(id, form) {
    return httpService.put(`/user/${id}`, form);
  },

  save(form) {
    return httpService.post(`/user`, form);
  },

  changePassword(form, id) {
    return httpService.put(`/user/${id}/change-password`, form)
  },

  delete(id) {
    return httpService.delete("/user/" + id);
  },

  findAll() {
    return httpService.get(`/user/findAll`);
  },

  findall(example, pageable) {
    pageable = utils.initPageableParams(pageable);
    let params = utils.merge(example, pageable);
    return httpService.get(`/user/findAll`, { params: params });
  },

  exportFile(data, params) {
    return httpService.postCustom("don/export?", data, { params });
  },

  findById(id) {
    return httpService.get("/user/" + id);
  },

  changeStatus(id, form) {
    return httpService.put(`/user/${id}/changeStatus`, form);
  },

  updateAvatar(data, id) {
    return httpService.post(`/user/${id}/updateAvatar`, data);
  },

  // Lấy avatar theo id
  getAvatarById(id) {
    return httpService.get("/user/getAvatar/" + id);
  },

  // Lấy danh sách hợp đồng
  findAllContract(userId) {
    return httpService.get(`/user/get-contract/${userId}`);
  },

  // Lấy thông tin CTS của user hiển tại
  getCertInfo(clientId) {
    return clientId
      ? httpService.get(`/user/cert-info?clientId=${clientId}`)
      : httpService.get(`/user/cert-info`);
  },

  // Thêm mới hợp đồng
  saveContract(form) {
    return httpService.post(`/user/add-contract`, form);
  },

  // Chỉnh sửa hợp đồng
  updateContract(form) {
    return httpService.put(`/user/update-contract`, form);
  },

  // Xóa hợp đồng
  deleteContract(id) {
    return httpService.delete(`/user/delete-contract/${id}`);
  },
};



// WEBPACK FOOTER //
// ./src/services/userService.js